import React, {Component} from 'react';
import { Alert, DatePicker } from 'antd';
import './CopyConfigDatePicker.css';
import {injectIntl} from 'react-intl';
import moment from 'moment';

import Constants from '../../../services/Constants';
import SAButton from '../../common/button/SAButton';
import FieldError from '../../common/input/FieldError';

class CopyConfigsDatePicker extends Component {
  handleOnChange = (date, dateString)=> {
    const {onChange} = this.props;
    let value = date;
    if (date){
      value = moment(date).format(Constants.DATE_FORMAT_API);
    }
    onChange(value, dateString);
  }

  extraFooter = () => {
    const {intl: {formatMessage}, multipleDays, onConfirm, onCancel, disabledButton, showError} = this.props;
    if (multipleDays) {
      return (
        <div>
          {showError &&
            <div style={{ lineHeight: '22px', paddingTop: '10px' }}>
              <Alert message={formatMessage({id: 'wheels-exchange-config.existing-configuration'})} type="warning" />
            </div>
          }
          <div className="calendar-btn">
            <SAButton
              disabled={disabledButton}
              type="primary"
              onClick={() => onConfirm()}
              >
                {formatMessage({id: 'menu.apply'})}
              </SAButton>
              <a onClick={() => onCancel()}
                 className="ant-table-filter-dropdown-link clear">{formatMessage({id: 'action.cancel'})}</a>
            </div>
        </div>
      );
    }
    return null;
  }

  disableDates = (date) => {
    const {onDisabledDate} = this.props;
    return moment(date).isBefore(moment().subtract(1, 'days')) ||
      moment(date).format(Constants.DATE_FORMAT_API) === onDisabledDate;
  };

  render() {
    const {className, error, onChange, value, onDisabledDate, multipleDays, onCopyConfigConfirm, isOpen,  ...attributes} = this.props;
    const errorClassName = error ? " error":'';
    const formattedValue = value ? moment(value, Constants.DATE_FORMAT_API) : null;

    return (
      <span className={className + errorClassName}>
        <DatePicker {...attributes}
          className='copy-configs-date-picker'
          value={formattedValue}
          format={Constants.DATE_FORMAT_DISPLAY}
          onChange={this.handleOnChange}
          disabledDate={(date) => this.disableDates(date)}
          open={isOpen}
          showToday={false}
          renderExtraFooter={this.extraFooter}
        />
        {error && (
          <FieldError error={error}/>
        )}
      </span>
    );
  }
}

export default injectIntl(CopyConfigsDatePicker);
